const { makeAutoObservable } = require("mobx");

class DataUserLoyalty {
    constructor() {
        makeAutoObservable(this);
    }

    images = [];
    userName = "";
    userSurname = "";
    userPhone = "";
    placeId = "";
}

export default new DataUserLoyalty();
